import { Box, Paper, Stack, Typography, styled, useTheme } from '@mui/material'
import React from 'react'
import ReactSpeedometer from 'react-d3-speedometer'
import GaugeChart from 'react-gauge-chart'

function InverterCard({ TYP, Title, Gauge, InvValue, Unit }) {
    const { spacing, shape: { borderRadius }, palette } = useTheme()

    const blinkingAnimation = {
        animation: 'blinkingAnimation 2s infinite',
        transition: 'color 0.5s ease-in-out',
        color: 'green', // Initial color
    }
    const blinkingAnimationBatStatus = {
        animation: 'blinkingAnimation 2s infinite',
        transition: 'color 0.5s ease-in-out',
        color: 'red', // Initial color
    }

    const blinkingAnimationDateTime = {
        fontWeight: "900",
        animation: 'blinkingAnimationDateTime 2s infinite',
        transition: 'color 0.5s ease-in-out',
    }

    const blinkingAnimationFaultPv = {
        fontWeight: "900",
        animation: 'blinkingAnimationFaultPv 2s infinite',
        transition: 'color 0.5s ease-in-out',
        // color: 'red', // Initial color

    }

    return (
        <Stack component={Paper} style={{ padding: spacing(1), borderRadius: borderRadius }} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
            <Stack rowGap={spacing(1)}>
                <Typography variant='body1' >{Title} :</Typography>
                {
                    Gauge ? (
                        <Stack direction={'row'} alignItems={'center'} justifyContent={'start'} columnGap={spacing(1)}>
                            <Typography variant={Gauge ? 'h4' : 'body1'} fontWeight={900}>{InvValue} </Typography>
                            <Typography variant='h5' fontWeight={'light'}> {Unit}</Typography>
                        </Stack>
                    ) : null

                }
            </Stack>
            <Box>
                {
                    Gauge ? (
                        <>
                            {/* <GaugeChart id="gauge-chart5"
                                nrOfLevels={420}
                                arcsLength={[0.3, 0.5, 0.2]}
                                colors={['#FED7AA', '#FB923C', '#EA580C']}
                                percent={InvValue}
                                textColor={palette.primary.dark}
                                cornerRadius={0}
                                hideText
                                animate={false}
                                style={{ width: '7rem', margin: 'auto' }}
                                arcPadding={0.0}
                            /> */}
                            <div>
                                {/* {console.log(MeterData?.max_range, typeof (+MeterData?.max_range))} */}
                                <ReactSpeedometer
                                    width={150}
                                    height={100}
                                    paddingHorizontal={10}
                                    paddingVertical={20}
                                    segments={2}
                                    value={InvValue}
                                    currentValueText={InvValue?.length <= 0 || InvValue == undefined ? "0" : `${InvValue} ${Unit}`}
                                    minValue={Unit == "Hz" ? 45 : 0}
                                    maxValue={
                                        (Unit == "V" && TYP == "SolarOverView") ? 1200 :
                                            (Unit == "V" && TYP == "BatteryOverView") ? 1200 :
                                                (Unit == "A" && TYP == "InputGroup") ? 400 :
                                                    (Unit == "A" && TYP == "OutputGroup") ? 400 :
                                                        (TYP == "InputActivePower" || TYP == "InputApparentPower") ? 200 :
                                                            (TYP == "InputPowerFactor") ? 1 :
                                                                Unit == "V" ? 300 :
                                                                    (Unit == "A" && TYP == "SolarOverView") ? 300 :
                                                                        (Unit == "A" && TYP == "BatteryOverView") ? 300 :
                                                                            Unit == "A" ? 200 :
                                                                                Unit == "KW" || Unit == "KVA" ? 100 :
                                                                                    Unit == "Hz" ? 55 :
                                                                                        Unit == "%" ? 100 :
                                                                                            Unit == "C" ? 100 : 500
                                    }
                                    segmentColors={['#FED7AA', '#FB923C', '#EA580C']}
                                    needleColor={palette.primary.main}
                                    textColor={palette.primary.main}
                                    needleHeightRatio={0.6}
                                />
                            </div>
                            {/* <Typography noWrap component={Paper}
                                bgcolor={palette.primary.light}
                                width={'5rem'} m={'auto'}
                                textAlign={'center'}
                                variant='body1'>{InvValue} {Unit}</Typography> */}
                        </>
                    ) : (
                        <Stack direction={'row'} alignItems={'center'} columnGap={spacing(1)}>
                            <Typography
                                fontWeight={'bold'}
                                variant={Title == "DateTime" ? 'body2' : 'h5'}
                                style={Title == "DateTime" ? blinkingAnimationDateTime : Title == "Battery Status" && InvValue == "Charging" ? blinkingAnimation : Title == "Battery Status" && InvValue == "Discharging" ? blinkingAnimationBatStatus : {}}
                            >
                                {InvValue?.length <= 0 || InvValue == undefined ? "0" : InvValue}
                            </Typography>

                            <Typography
                                variant='body2'
                                fontWeight={900}> {Unit}</Typography>
                        </Stack>

                    )
                }

            </Box>
        </Stack>
    )
}

export default InverterCard
